import { Link } from 'react-router-dom'
import { PageWrapper } from '../components/layout/PageWrapper'
import { Button } from '../components/ui/Button'
import { Seo } from '../components/Seo'

export function NotFound() {
  return (
    <PageWrapper>
      <Seo title="Page not found (404)" description="Sorry, we couldn't find that page." noindex />
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <h1 className="text-6xl font-extrabold text-gray-200 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Page not found</h2>
        <p className="text-gray-500 mb-8">Sorry, the page you're looking for doesn't exist or has moved.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/"><Button variant="primary">Get an emergency plumber</Button></Link>
          <Link to="/plumbers"><Button variant="secondary">Browse the directory</Button></Link>
        </div>
        <p className="mt-8 text-sm text-gray-500">
          Or read our <Link to="/blog" className="text-trust-600 hover:underline">plumbing guides</Link>,{' '}
          <Link to="/browse" className="text-trust-600 hover:underline">browse plumbers by area</Link>, or see{' '}
          <Link to="/how-it-works" className="text-trust-600 hover:underline">how FixDelivered works</Link>.
        </p>
      </div>
    </PageWrapper>
  )
}
